import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Link } from '@/features/Link';

import styles from './Footer.scss';


const socials = [
    {
        name: 'vk',
        url : 'https://vk.com/s7airlines',
    },
    {
        name: 'ok',
        url : 'https://ok.ru/s7airlines',
    },
    {
        name: 'youtube',
        url : 'https://www.youtube.com/user/S7Group',
    },
    {
        name: 'telegram',
        url : 'https://t.me/s7airlines',
    },
];


export const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer data-qa='tp_footer'>
            <div className={ styles.inner_wrapper }>
                <div className={ styles.row }>
                    <p className={ styles.copyright }>
                        © { new Date().getFullYear() }. { t('common.footer.copyright') }
                    </p>

                    <ul className={ styles.socials }>
                        {
                            socials.map(({ name, url }) => (
                                <li key={ name }>
                                    <Link
                                        href={ url }
                                        target={ '_blank' }
                                        className={ classNames(styles.social_item, styles[`social_item_${name}`]) }
                                    />
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </footer>
    );
};
